import FormMock from '../static/api/mock/FormMock.js'
    export default class FormService {
     static getResult(pointSum,formId)
     {
         
         return FormMock.getResult(pointSum,formId)['data']['result']
     }
    static getForm(id) {
        var query = ` query { 
            form(`+id+`){
                id 
            }
        }`
        console.log(FormMock.get(query,id))
        var list = FormMock.get(query,id)['data']['form']

        return list
    }
} 


// WEBPACK FOOTER //
// ./src/dao/FormService.js